module.exports = __webpack_public_path__ + "img/fondo1.dcb472e8.png";